// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.average__bC2tjoVFe9{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/dashboard/views/queue/components/queues/components/metrics/components/dailyConversations/dailyConversationsMetric.module.scss"],"names":[],"mappings":"AAAA,qBACE,kBAAA","sourcesContent":[".average {\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"average": `average__bC2tjoVFe9`
};
export default ___CSS_LOADER_EXPORT___;
